import { useEffect } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, Controller } from 'react-hook-form'

import schema from '../../../../../../validators/adminSchema'
import { Button } from '../../../../../../components/Button'
import { Input } from '../../../../../../components/FormElements/Input'
import { type AdminPersistence } from '../../../../../../types/persistence/admin-persistence'
import { isEmailAvailable } from '../../../../../../utils/isEmailAvailable'

type AdminFormProps = {
  isSubmitting: boolean
  defaultValues?: AdminPersistence
  onSubmit: (data: AdminPersistence) => void
}

export const AdminForm = ({
  isSubmitting,
  defaultValues,
  onSubmit,
}: AdminFormProps) => {
  const { control, formState, reset, handleSubmit, clearErrors, setError } =
    useForm<AdminPersistence>({
      defaultValues,
      resolver: yupResolver(schema),
      mode: 'onChange',
    })

  useEffect(() => {
    return () => {
      reset()
    }
  }, [reset])

  return (
    <form
      className="p-6 max-h-[80vh] overflow-y-auto scrollbar"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="mb-14">
        <div className="mb-4">
          <Controller
            name="name"
            control={control}
            render={({
              field: { value = '', onChange },
              fieldState: { invalid, error },
            }) => (
              <Input
                label="Nome completo"
                autoFocus
                placeholder="Nome completo"
                isValid={!invalid && !!error}
                value={value}
                onChange={onChange}
                errorMessage={error?.message}
              />
            )}
          />
        </div>

        <Controller
          name="email"
          control={control}
          render={({
            field: { value = '', onChange },
            fieldState: { invalid, error },
          }) => (
            <Input
              label="E-mail"
              placeholder="E-mail"
              isValid={!invalid && !!error}
              value={value}
              onChange={async (event) => {
                onChange(event)

                const emailFieldValue = event.target.value
                const defaultEmailValue = defaultValues?.email
                const isNotEmailAvailable = !(await isEmailAvailable(
                  emailFieldValue,
                  defaultEmailValue
                ))

                if (isNotEmailAvailable) {
                  setError('email', { message: 'E-mail já em uso' })
                  return
                }

                clearErrors('email')
              }}
              errorMessage={error?.message}
            />
          )}
        />
      </div>

      <Button
        type="submit"
        disabled={!formState.isValid}
        isLoading={isSubmitting}
        fullWidth
      >
        {defaultValues ? 'Salvar' : 'Cadastrar'}
      </Button>
    </form>
  )
}
